
import axios from 'axios'
import library from '../../../utils/Library'

export const getParametersApplication = async (appCode) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') + '/getAllApplicationParameterEAuthz'

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      appCode
    }
  })
}
